import React, {Component} from "react";
import {Button, Layout, Menu,} from 'antd';
import * as Icon from "@ant-design/icons";
import {AppstoreOutlined} from "@ant-design/icons";
import store from "store";
import {FunctionProps} from "../pages/admin/model/function";

const { SubMenu } = Menu;

// 创建类型接口
interface IProps {
    SelectedKeys?: string[],
    OpenKeys?: string[],
}

export default class SiderMenuMain extends Component<IProps> {

    state = {
        collapsed: false,
    };

    handleClick = (e: { key: any; }) => {
        console.log('click ', e);
        //this.setState({ current: e.key });
    };

    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    render() {
        const login_power = store.get('login_power') || [];
        const hashPath = window.location.hash.split('?')[0];
        const hashStrs = hashPath.split('/');
        const menus = login_power.filter((el:any) => {return el.page_url.split('/')[0] === hashStrs[1]})

        let SelectedKeys = this.props.SelectedKeys;
        let OpenKeys = this.props.OpenKeys || [];

        const isValidKey =(key: React.Key, obj: {[propName: string]: any}) => {
            // console.log(key,obj);
            return key in obj;
        }
        const renderMenus = (menus : any[] ) => {
            let my: any[] = [];
            menus.forEach((item: FunctionProps) => {
                const reg=/(^\/)|(\/$)/g;
                if (!SelectedKeys && item.page_url.replace(reg,'') === hashPath.substring(2).replace(reg,'')) {
                    SelectedKeys = [item.page_url];
                }
                if (item.children && item.children.length > 0) {
                    if (!this.props.OpenKeys) {
                        OpenKeys.push(item.page_url);
                    }
                    my.push (
                        <SubMenu key={item.function_id}  title={item.function_name}>
                            {renderMenus(item.children)}
                        </SubMenu>
                    )
                } else {
                    my.push (
                        // @ts-ignore
                        <Menu.Item key={item.page_url}  icon={React.createElement(isValidKey(item.icon,Icon) ? Icon[item.icon] : Icon['AppstoreOutlined'])}>
                            <a href={'/#/' + item.page_url}> {item.function_name}</a>
                        </Menu.Item>
                    )
                }
            })
            return my;
        }
        const siderMenu = menus ? menus[0] ? menus[0].children ? renderMenus(menus[0].children) : [] : [] : [];
        //console.log(SelectedKeys,OpenKeys);
        if (!SelectedKeys || SelectedKeys===[]) {
            window.location.replace('/');
            return ;
        }

        return (
            <Layout.Sider width={240}
                          theme="light"
                          collapsed={this.state.collapsed}
                          style={{ marginTop: -8}}>
                <Button type={'link'} onClick={this.toggleCollapsed} style={{ margin: 0, marginLeft: 16  }}>
                    {React.createElement(this.state.collapsed ? Icon['MenuUnfoldOutlined'] : Icon['MenuFoldOutlined'])}
                </Button>
                <Menu mode="inline"
                      defaultSelectedKeys={SelectedKeys}
                      defaultOpenKeys={OpenKeys}
                      onClick={this.handleClick}
                      style={{height: '90%', position:"relative"}}
                >
                    {siderMenu}
                </Menu>
                <div hidden={true}><AppstoreOutlined /></div>
            </Layout.Sider>
        );
    }
}